<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  href: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <template v-if="props.href">
    <a :href="props.href" v-bind="$attrs">
      <slot></slot>
    </a>
  </template>
  <template v-else>
    <slot></slot>
  </template>
</template>

<style lang="scss" scoped>
</style>
